import { Settings } from '@mui/icons-material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, Divider, Link } from '@mui/material';
import Typography from '@mui/material/Typography';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { Trans, useTranslation } from 'react-i18next';
import { BenefitPaper } from '../../component/benefitTabs/BenefitPaper';
import { HorizontalBox, VerticalBox } from '../../component/layout/BoxLayout';
import { FEATURE_ONEPORTAL_V2 } from '../../constants';
import { getBenefitIcon } from '../../module/benefits/BenefitIcon';
import BenefitSubPage from '../../module/benefits/BenefitSubPage';
import BikeleasingSettingsForm from '../../module/benefits/bikeleasingV2/BikeleasingSettingsForm';
import { useBikeleasingPortalLinkBuilder } from '../../module/benefits/bikeleasingV2/bikeleasingPortalLink';
import { useBikeleasingPrecondition } from '../../module/benefits/bikeleasingV2/useBikeleasingPrecondition';
import { AuthorizedLayout } from '../../module/navigation/AuthorizedLayout';

const BikeleasingSettingsLinkOut: React.FC = () => {
  const { t } = useTranslation('extensions');
  const buildBikeleasingPortalLink = useBikeleasingPortalLinkBuilder();
  const bikeleasingEmployerProfileUrl = buildBikeleasingPortalLink(`/user/company-profile/employer`);

  return (
    <Box sx={{ p: 1.5 }}>
      <VerticalBox>
        <HorizontalBox sx={{ gap: 1, alignItems: 'center' }}>
          <Settings fontSize="large" />
          <Typography variant="h2">{t('bikeleasing_v2.settings.infoTitle')}</Typography>
        </HorizontalBox>
      </VerticalBox>
      <Divider sx={{ my: 3 }} />
      <Box>
        <Trans i18nKey="extensions:bikeleasing_v2.settings.infoText" />
        <Link
          href={bikeleasingEmployerProfileUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ ml: 0.5, flex: 1, display: 'inline-flex', alignItems: 'center', gap: 0.5 }}
        >
          {t('extensions:bikeleasing_v2.settings.infoAction')}
          <OpenInNewIcon fontSize="small" />
        </Link>
      </Box>
    </Box>
  );
};

const BikeleasingSettingsPage: React.FC = () => {
  const { t } = useTranslation('extensions');
  const { PreconditionComponent, isPreconditionMet } = useBikeleasingPrecondition();

  return (
    <AuthorizedLayout
      title={t('bikeleasing_v2.settings.title')}
      breadcrumbs={[{ title: t('bikeleasing_v2.title'), to: `/benefits/${BenefitDTOBenefitEnum.BikeleasingV2.toLowerCase()}` }]}
    >
      <BenefitSubPage
        icon={getBenefitIcon(BenefitDTOBenefitEnum.BikeleasingV2)}
        title={t('bikeleasing_v2.title')}
        subTitle={t('bikeleasing_v2.settings.title')}
      >
        <BenefitPaper>
          {!isPreconditionMet ? PreconditionComponent : FEATURE_ONEPORTAL_V2 ? <BikeleasingSettingsForm /> : <BikeleasingSettingsLinkOut />}
        </BenefitPaper>
      </BenefitSubPage>
    </AuthorizedLayout>
  );
};

export default BikeleasingSettingsPage;
